import {BaseComponent} from "../../Library/BaseComponent";
import {Component, OnChanges, OnInit, SimpleChange, ViewChild} from "@angular/core";
import {AuthActionCodes, EntityCodes, FilterTypes, RecurrenceSearch_GroupBy} from "../../Models/EnumModels";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute, Router} from "@angular/router";
import {MasterDataService} from "../../Services/MasterDataService";
import {RecurrenceConsoleService} from "../../Services/RecurrenceConsoleService";
import {NgbModal, NgbModalOptions, NgbTypeaheadSelectItemEvent} from "@ng-bootstrap/ng-bootstrap";
import {GenericMaster, PropertyBasicInfo} from "../../Models/GlobalEntities";
import {SearchTextResult, TopFilterStatModel} from "../../Models/CommonModels";
import {RecurrenceFilterModel, RecurrenceQuery} from "../../Models/RequestModels";
import {Observable, of} from "rxjs";

import {catchError, debounceTime, distinctUntilChanged, switchMap} from "rxjs/operators";
import {RecurrenceSearchResult} from "../RecurrenceSearchResult/RecurrenceSearchResult";
import {ListResponse, SimpleResponse, StatusCodeCount} from "../../Models/ResponseModels";
import {cloneDeep} from "lodash";
import {RecurrenceStatus} from "../../enum/RecurrenceStatus";
import {JobFilter} from "../JobFilter/JobFilter";
import {AppSettings} from "../../Library/AppSettings";

@Component({
    selector: 'PaginatedRecurrenceConsole',
    templateUrl: './PaginatedRecurrenceConsole.html'
})
export class PaginatedRecurrenceConsole extends BaseComponent implements OnInit, OnChanges {
    @ViewChild("grdSearchResult") grdSearchResult: RecurrenceSearchResult;
    @ViewChild('recurrenceKey') recurrenceKey;
    @ViewChild("jobFilter") jobFilter: JobFilter;

    Selected;
    RecurrenceFilters: Array<FilterTypes> = [
        FilterTypes.CallDescription,
        FilterTypes.Dept,
        FilterTypes.Location,
        FilterTypes.RoomStatus,
        FilterTypes.EndPattern,
        FilterTypes.NextOccurrence
    ];
    lstProperties: Array<PropertyBasicInfo> = [];
    SelectedProperties: Array<number> = [];
    PropStatModel: Array<TopFilterStatModel>;
    RequestModel: RecurrenceQuery;
    FilterModel: RecurrenceFilterModel;
    KeywordSearch?: string;
    SearchOnEntities: Array<EntityCodes> = [
        EntityCodes.CallDescriptions,
        EntityCodes.Dept,
        EntityCodes.Location,
        EntityCodes.Staff,
    ];
    GroupTypes: Array<GenericMaster> = [];
    _RecurrenceSearch_GroupBy = RecurrenceSearch_GroupBy;
    ResultModel;
    propertyMasterCache: Record<EntityCodes, Array<any>>;
    AppSettings = AppSettings;

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        public recurrenceConsoleService: RecurrenceConsoleService,
        protected modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.PopulateTopFilters();
        this.lstProperties = this.masterService.GetProperties_Action(
            AuthActionCodes.RecurrenceView
        );
        this.InitRequestModel();
        this.InitCache(this.RequestModel.Properties);
        this.InitFilterModel();
        this.InitGroupModel(RecurrenceSearch_GroupBy);
        this.OnRefreshClick();
    }

    ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    }

    ngOnDestroy() {
        this.recurrenceConsoleService.SelectedRecurrence = null;
    }

    OnRowDelete(event) {
        if (!event) {
            return;
        }
        this.recurrenceConsoleService.RecurrenceDeleted.emit(event);
        this.ResultModel = this.recurrenceConsoleService.RecurrenceDeleteForResults(this.ResultModel, event);
    }

    private PopulateTopFilters() {
        this.PropStatModel = [
            {
                Id: null,
                IconClass: 'fa fa-bars',
                Label: 'LBL.ALL',
                Value: 0
            },
            {
                Id: "Y",
                IconClass: 'fa fa-unlock-alt',
                Label: 'LBL.ACTIVE',
                Value: 0
            },
            {
                Id: "N",
                IconClass: 'fa fa-lock',
                Label: 'LBL.EXPIRED',
                Value: 0
            },
            {
                Id: "D",
                IconClass: 'fa fa-trash',
                Label: 'LBL.DELETED',
                Value: 0
            }
        ]
    }

    private InitCache(propertyIds?: number[]) {
        propertyIds = propertyIds || (this.lstProperties || []).map(p => p.PropertyId);
        this.propertyMasterCache = this.masterService.GetTypeaheadMasters(propertyIds, this.SearchOnEntities);
    }

    private InitRequestModel() {
        this.RequestModel = new RecurrenceQuery();
        this.RequestModel.StatusCode = 'Y';
        this.RequestModel.RoomStatus = '';
        this.InitDefaultProperty();
    }

    private InitDefaultProperty() {
        const defaultProperty = this.masterService.GetDefaultProperty_Action(AuthActionCodes.RecurrenceView);
        this.RequestModel.Properties = defaultProperty ? [defaultProperty] : [];
    }

    private InitFilterModel() {
        this.FilterModel = new RecurrenceFilterModel();
        this.FilterModel.Properties = [];
        this.FilterModel.SetDefaults();
        this.FilterModel.Properties = this.RequestModel.Properties;
    }

    private InitGroupModel(enumerationType) {
        this.GroupTypes = [];
        if (enumerationType === null || enumerationType === undefined) {
            return;
        }
        const rows = Object.keys(enumerationType)
            .filter(row => typeof enumerationType[row] === 'number');

        const isMultiProperty = this.lstProperties && this.lstProperties.length > 1;

        this.GroupTypes = rows
            .map(row => {
                if (!isMultiProperty && row === 'Property') {
                    return null;
                }
                const grouping = new GenericMaster();
                grouping.Id = enumerationType[row];
                grouping.Name = grouping.Id === 0
                    ? 'CMB_DEF.NO_GROUPING'
                    : `ENTITIES.ENTITIES_${row}`
                return grouping;
            })
            .filter(row => row);
    }

    private SetData() {
        if (this.RequestModel.GroupBy == RecurrenceSearch_GroupBy.None) {
            this.grdSearchResult.RequestModel = this.RequestModel;
            this.grdSearchResult.Show();
            return;
        }
        this.IsSubmitting = true;
        this.ResultModel = new ListResponse();
        return this.recurrenceConsoleService.Recurrence_Query(this.RequestModel)
            .then(data => {
                this.IsSubmitting = false;
                this.ResultModel = data;
                this.RequestModel.PageNumber = data && data.CurrentPage;
            })
            .catch(reason => {
                this.IsSubmitting = false;
            })
    }

    private SetCountsData() {
        const promise = this.recurrenceConsoleService.Recurrence_QueryCount(this.RequestModel)
            .then(response => {
                this.UpdatePropStatModel(response);
            });

            promise.catch(reason => {
                console.error(`Recurrence Console Count Failed - ${reason}`, this.RequestModel);
            });
        return promise;
    }

    private UpdatePropStatModel(response: SimpleResponse<Array<StatusCodeCount>>) {
        const data = (response && response.Result) || [];
        const transform = data.reduce((acc, statCount) => {
            if (!acc[statCount.StatusCode]) {
                acc[statCount.StatusCode] = 0
            }
            acc[statCount.StatusCode] += statCount.Count || 0;
            return acc;
        }, {}) as Record<string, number>
        const totalCount = Object.values(transform).reduce((acc, count) => acc + count, 0);
        this.PropStatModel = cloneDeep(this.PropStatModel).map(item => {
            item.Value = item.Id
                ? (transform[item.Id] || 0)
                : totalCount
            return item;
        });
    }

    // Property Selector
    private updateSelectedProperties(propertyId: number, newState: boolean) {
        this.SelectedProperties = this.SelectedProperties || [];
        const index = this.SelectedProperties.indexOf(propertyId);
        if (newState && index >= 0) {
            return;
        }
        if (!newState && index < 0) {
            return;
        }
        if (newState) {
            this.SelectedProperties.push(propertyId);
        } else {
            this.SelectedProperties.splice(index, 1);
        }
    }

    OnPropertySelectorOpened(event) {
        if (event) {
            this.SelectedProperties = this.RequestModel.Properties.slice();
        }
    }

    IsAllPropertiesSelected(): boolean {
        const allProperties = this.lstProperties || [];
        const selectedPropertyIds = this.SelectedProperties || [];
        if (!allProperties.length) {
            return false;
        }
        if (!selectedPropertyIds.length) {
            return false;
        }
        if (allProperties.length !== selectedPropertyIds.length) {
            return false;
        }

        for (const property of allProperties) {
            if (selectedPropertyIds.indexOf(property.PropertyId) < 0) {
                return false;
            }
        }

        return true;
    }

    IsSomePropertiesSelected(): boolean {
        return !!(this.SelectedProperties
            && this.SelectedProperties.length)
    }

    OnPropertyToggle(event) {
        const newState = event && event.target && event.target.checked;
        for (const property of this.lstProperties) {
            this.updateSelectedProperties(property.PropertyId, newState);
        }
    }

    IsPropertySelected(propertyId: number): boolean {
        return this.IsSomePropertiesSelected()
            && (this.SelectedProperties.indexOf(propertyId) >= 0);

    }

    OnPropertySelected(propertyId: number, event) {
        const newState = event && event.target && event.target.checked;
        this.updateSelectedProperties(propertyId, newState);
    }

    OnPropertyChange() {
        if (!this.SelectedProperties || !this.SelectedProperties.length) {
            this.InitDefaultProperty();
        } else {
            this.RequestModel.Properties = this.SelectedProperties.slice();
        }
        this.InitCache(this.RequestModel.Properties);
        this.OnFilterClear();
        this.OnRefreshClick();
    }

    // Top Filter Selector
    OnTopFilterClick(id?: string) {
        this.RequestModel.StatusCode = id;
        if (id) {
            this.RequestModel.LastUpdateEndTime = null;
            this.RequestModel.LastUpdateStartTime = null;
        }
        this.OnRefreshClick();
    }

    // Search
    SearchStringTypeahead = (term$: Observable<string>) => term$.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((term) =>
            this.OnSearchTypeahead(term).pipe(
                catchError(() => {
                    return of([]);
                })
            )
        )
    );

    SearchFilterDisplayText(value?: SearchTextResult): string {
        if (value === null || value === undefined) {
            return '';
        }
        if (typeof value !== 'object') {
            return value;
        }
        return value.Term;
    }

    OnSearchTypeahead(term?: string): Observable<SearchTextResult[]> {
        const result: SearchTextResult[] = [];
        if (term === null || term === undefined || term.length === 0) {
            return of(result);
        }
        const mastersSearchResults = this.masterService.GetSearchResultsForTypeahead(this.propertyMasterCache, term);
        return of(result.concat(mastersSearchResults));
    }

    OnSearchFilter(event: NgbTypeaheadSelectItemEvent) {
        const selected = event.item as SearchTextResult;
        const statusCode = this.RequestModel.StatusCode;
        const request = this.RequestModel;
        const cache = {
            [selected.Entity] : this.propertyMasterCache[selected.Entity]
        } as Record<EntityCodes, Array<any>>;
        const filtered = this.masterService.SearchTypeaheadMasters(cache, selected.Term);
        const selectedIds = (filtered[selected.Entity] || [])
            .map(m => m.Id)
            .filter(m => !m.Id);

        switch (selected.Entity) {
            case EntityCodes.CallDescriptions:
                request.CallDescriptions = selectedIds;
                break;
            case EntityCodes.Dept:
                request.Departments = selectedIds;
                break;
            case EntityCodes.Location:
                request.Locations = selectedIds;
                break;
            case EntityCodes.Staff:
                // request.RecurrenceStaffs = selectedIds;
                request.LoggedBy = selectedIds;
                break;
        }
        this.RequestModel = Object.assign(new RecurrenceQuery(), request);
        this.SetData();
    }

    // Grouping
    OnGroupingChanged() {
        this.SetData();
    }

    OnGroupingCleared() {
        this.RequestModel.GroupBy = RecurrenceSearch_GroupBy.None;
        this.OnGroupingChanged();
    }

    // Advanced Filters
    OnFilterOpen() {
        if (this.jobFilter && this.RequestModel) {
            this.jobFilter.onOpen(this.RequestModel)
        }
    }
    HasFilters() {
        return this.RequestModel && (
            (this.RequestModel.Locations && this.RequestModel.Locations.length)
            || (this.RequestModel.Departments && this.RequestModel.Departments.length)
            || (this.RequestModel.CallDescriptions && this.RequestModel.CallDescriptions.length)
            || (this.RequestModel.lstEndPattern && this.RequestModel.lstEndPattern.length)
            || (this.RequestModel.LoggedBy && this.RequestModel.LoggedBy.length)
            || (this.RequestModel.RequestedBy && this.RequestModel.RequestedBy.length)
            || (this.RequestModel.ReportedBy && this.RequestModel.ReportedBy.length)
            || (this.RequestModel.RecurrenceFrequency !== undefined && this.RequestModel.RecurrenceFrequency !== null)
            || (this.RequestModel.RecurrencePattern !== undefined && this.RequestModel.RecurrencePattern !== null)
            || (this.RequestModel.RegisterAtEndOfMonth !== undefined && this.RequestModel.RegisterAtEndOfMonth !== null)
            || (this.RequestModel.Keyword && this.RequestModel.Keyword.trim().length)
            || (this.RequestModel.RoomStatus)
            || (this.RequestModel.IsGuestCall)
            || (this.RequestModel.DateRangeStart)
            || (this.RequestModel.DateRangeEnd)
            || (this.RequestModel.ReopenStartTime)
            || (this.RequestModel.ReopenEndTime)
            || (this.RequestModel.LastUpdateStartTime)
            || (this.RequestModel.LastUpdateEndTime)
        )
    }

    OnFilterClear() {
        this.ResetFilterState();
        this.OnRefreshClick();
    }

    private ResetFilterState() {
        const selectedProperties = this.RequestModel.Properties.slice();
        const selectedStatus = this.RequestModel.StatusCode;
        const selectedGrouping = this.RequestModel.GroupBy || RecurrenceSearch_GroupBy.None;
        this.InitRequestModel();
        this.KeywordSearch = '';
        this.RequestModel.Properties = selectedProperties;
        this.RequestModel.GroupBy = selectedGrouping;
        this.RequestModel.StatusCode = selectedStatus;
    }

    didApplyFilters(requestModel: unknown) {
        if (!requestModel) {
            return;
        }
        this.RequestModel = Object.assign(new RecurrenceQuery(), requestModel);
        this.OnRefreshClick();
    }

    OnMonthChange(jsMonth: string) {
        if (!this.RequestModel || this.RequestModel.StatusCode === 'Y' || this.RequestModel.StatusCode === 'D') {
            return;
        }
        const months = +jsMonth;
        if (!isNaN(months)) {
            const currentDate = new Date()
            const currentMonth = currentDate.getMonth();
            const lowerDateLimit = new Date();
            lowerDateLimit.setMonth(currentMonth - months);
            this.RequestModel.LastUpdateStartTime = lowerDateLimit;
            this.RequestModel.LastUpdateEndTime = currentDate;
        } else if (jsMonth === 'All') {
            this.RequestModel.LastUpdateStartTime = null;
            this.RequestModel.LastUpdateEndTime = null;
        }

        this.SetData();
    }

    // Console Action
    OnRefreshClick() {
        return Promise.all([
            this.SetCountsData(),
            this.SetData()
        ])
    }

    OnExportToExcel() {

    }

    OnLegendModalOpen() {
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            size: 'lg',
            centered: true
        };
        this.modalService.open(this.recurrenceKey, ngbModalOptions);
    }

    // Selection
    OnSelectedChange(event) {}
}
